"use strict";

exports.__esModule = true;
exports.LogbookPanel = void 0;
var _uiSwitch = require("../Theme/UiDesign/uiSwitch");
var _LogbookPanel = require("./LogbookPanel.legacy");
var _LogbookPanel2 = require("./LogbookPanel.modern");
// Flag-gated UI: `LogbookPanel.legacy` is the component as it is on master,
// `LogbookPanel.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var LogbookPanel = exports.LogbookPanel = (0, _uiSwitch.uiSwitch)(_LogbookPanel.LogbookPanel, _LogbookPanel2.LogbookPanel, "LogbookPanel");